import axios from 'axios'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import { useApi } from '@/functions/api'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'

export function useInitApp () {
  const route = useRoute()
  const router = useRouter()

  const api = useApi()
  const auth = useAuthStore()
  const app = useAppStore()

  type ResponseInit = {
    balance: number,
  }

  const init = async () => {
    try {
      const response = await api.GET<ResponseInit>('admin/init')
      if (isOnGuestPage(route.name as string)) {
        await router.replace('/' + (route.query.r ?? ''))
      }
      auth.setAuthenticated(1)
      app.setBalance(response.balance)
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        if (!isOnGuestPage(route.name as string)) {
          const path = route.fullPath.replace(/^\/+/, '')
          const query = path ? { r: path } : undefined
          router.replace({ name: 'login', query })
        }
        auth.setAuthenticated(0)
      }
    }

  }

  return {
    init,
  }
}

export function useRefreshBalance () {
  const api = useApi()
  const app = useAppStore()
  const loadingBalance = ref(false)

  const getBalance = async () => {
    loadingBalance.value = true
    const response = await api.GET<{ balance: number }>('admin/balance')
    app.setBalance(response.balance)
    loadingBalance.value = false
  }

  return {
    loadingBalance,
    getBalance,
  }
}

// route where authenticated user should not be able to access
export function isOnGuestPage (routeName: string) {
  return ['login'].includes(routeName)
}
